import React from 'react';
import { ClientAppProvider } from 'app/shared-components/client/ClientAppContext';

const withClientContext = (Component) => {
  return (props) => (
    <ClientAppProvider>
      <Component {...props} />
    </ClientAppProvider>
  );
};

export default withClientContext;